import { format, parse } from "date-fns";
import { EventManyQuery } from "gql/generated";
import _ from "lodash";
import { useEffect, useState } from "react";
import { EVENT_DATE_FORMAT } from "shared/utils";
import { useEventsWidgetContext } from "../EventsContext";

type EventGroup = {
  startDate: string;
  formattedDate: string;
  events: EventManyQuery["eventMany"][0][];
};

export const useRecurringEvents = (
  events: EventManyQuery["eventMany"][0][],
) => {
  const { locale } = useEventsWidgetContext();
  /**
   * When the events are updated, sort them into groups
   */
  const [eventGroups, setEventGroups] = useState<EventGroup[]>([]);
  useEffect(() => {
    // Get the unique start dates
    const startDates = Array.from(
      new Set(
        events.map((event) =>
          event.occurrences && event.occurrences.length > 0
            ? event.occurrences[0]
            : "",
        ),
      ),
    );
    const groups: EventGroup[] = startDates.map((startDate) => ({
      startDate: startDate as string,
      formattedDate: format(
        parse(startDate as string, EVENT_DATE_FORMAT, new Date()),
        "LLL d",
        { locale },
      ),
      events: events.filter(
        (event) =>
          event.occurrences &&
          event.occurrences.length > 0 &&
          event.occurrences[0] === startDate,
      ),
    }));
    setEventGroups(_.sortBy(groups, "startDate"));
  }, [events, locale]);

  return {
    eventGroups,
  };
};
